import React from 'react';

var LocationIcon = function LocationIcon(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "#fff" : _ref$backgroundColor,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000" : _ref$color;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16",
    height: "18",
    viewBox: "0 0 16 18"
  }, React.createElement("defs", null, React.createElement("path", {
    id: "btw9mhzxra",
    d: "M0 0h15.726v18H0z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("mask", {
    id: "xmo8cklh2b",
    fill: backgroundColor
  }, React.createElement("use", {
    xlinkHref: "#btw9mhzxra"
  })), React.createElement("path", {
    fill: color,
    d: "M7.863.947C4.052.947.953 4.033.953 7.825c0 3.342 5.564 8.016 6.91 9.097 1.345-1.082 6.91-5.757 6.91-9.097 0-3.792-3.1-6.878-6.91-6.878m0 17.053a.475.475 0 01-.29-.098C7.264 17.666 0 12.07 0 7.825 0 3.51 3.527 0 7.863 0s7.863 3.51 7.863 7.825c0 4.245-7.264 9.84-7.574 10.077a.474.474 0 01-.289.098",
    mask: "url(#xmo8cklh2b)"
  }), React.createElement("path", {
    fill: color,
    d: "M9.492 7.027c0 .895-.729 1.621-1.63 1.621a1.625 1.625 0 01-1.628-1.621c0-.896.73-1.622 1.629-1.622.9 0 1.63.726 1.63 1.622"
  })));
};

export default LocationIcon;